<template>
    <div class="flex -mx-2">
        <div class="w-1/3 px-2 hidden xl:block">
            <h3 class="text-md font-semibold">Password</h3>
            <div
                class="mt-2 text-sm text-gray-800"
            >Ensure your account is using a long, random password to stay secure.</div>
        </div>

        <transition name="fade" mode="out-in">
            <div class="w-full px-2 xl:w-2/3" v-if="resource.ready">
                <div class="card mb-5">
                    <div class="card-title" v-once>
                        <span v-if="editing">{{ entry.full_name }}</span>
                        <span v-else>Создать пользователя</span>
                    </div>

                    <form class="spaced-y-4" @submit.prevent="submit">
                        <p class="text-gray-800 font-medium mb-2">Данные профиля</p>

                        <div class="flex -mx-2">
                            <text-field
                                class="w-1/2 px-2"
                                title="Имя"
                                v-model="entry.first_name"
                                :errors="errors.first_name"
                                required
                            />

                            <text-field
                                class="w-1/2 px-2"
                                title="Фамилия"
                                v-model="entry.last_name"
                                :errors="errors.last_name"
                                required
                            />
                        </div>

                        <div class="flex -mx-2">
                            <text-field
                                class="w-1/2 px-2"
                                title="Email"
                                v-model="entry.email"
                                :errors="errors.email"
                                type="email"
                                required
                            />

                            <text-field
                                class="w-1/2 px-2"
                                title="Номер телефона"
                                v-model="entry.phone"
                                :errors="errors.phone"
                            />
                        </div>

                        <div class="flex -mx-2">
                            <text-field
                                class="w-1/2 px-2"
                                title="Пароль"
                                v-model="entry.password"
                                :errors="errors.password"
                                type="password"
                            />

                            <text-field
                                class="w-1/2 px-2"
                                title="Подтверждение пароля"
                                v-show="entry.password"
                                v-model="entry.password_confirmation"
                                type="password"
                            />
                        </div>

                        <div class="flex -mx-2">
                            <select-field
                                class="w-1/2 px-2"
                                title="Филиал"
                                label="name"
                                valueName="id"
                                :clearable="false"
                                :options="selects.branches"
                                v-model="entry.branch_id"
                                :errors="errors.branch_id"
                            />

                            <text-field
                                type="number"
                                class="w-1/2 px-2"
                                title="Баланс"
                                v-model="entry.balance"
                                :errors="errors.balance"
                                required
                            />
                        </div>

                        <hr class="mb-4" />

                        <div class="flex -mx-2">
                            <text-field
                                type="text"
                                class="w-1/2 px-2"
                                title="ID amoCRM"
                                v-model="entry.amo_id"
                                :errors="errors.amo_id"
                            />

                            <text-field
                                v-show="entry.role && entry.role.name === 'partner'"
                                type="text"
                                class="w-1/2 px-2"
                                title="Тег amoCRM"
                                v-model="entry.amo_tag"
                                :errors="errors.amo_tag"
                            />
                        </div>

                        <hr class="mb-4" />

                        <p class="text-gray-800 font-medium mb-2">Доступ</p>

                        <div class="flex -mx-2">
                            <select-field
                                class="w-1/2 px-2"
                                title="Роль"
                                label="title"
                                valueName="id"
                                :clearable="false"
                                :options="selects.roles"
                                v-model="entry.roles[0]"
                                :errors="errors['roles.0']"
                            />

                            <select-field
                                class="w-1/2 px-2"
                                title="Дополнительные права доступа"
                                :multiple="true"
                                label="title"
                                valueName="id"
                                :options="selects.permissions"
                                v-model="entry.permissions"
                                :errors="errors.permissions"
                            />
                        </div>

                        <hr class="mb-3" />

                        <router-link
                            class="btn btn-warning"
                            :to="{
                            name: 'admin.billing.withdrawal.users.form',
                            params: {id: this.entry.id}
                        }"
                        >Снять средства</router-link>

                        <button class="btn btn-primary">Сохранить</button>
                    </form>
                </div>

                <transactions
                    v-if="can('access-transactions') && editing"
                    modelType="user"
                    :modelId="entry.id"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Transactions from "../../../views/admin/billing/transactions/index";
import timezones from "@/static/timezones.json";

export default {
    extends: ResourceForm,

    components: {
        Transactions
    },

    data() {
        return {
            resource: {
                name: "admin.users",
                endpoint: "admin/users"
            },

            entry: {
                roles: []
            },

            selects: {
                ready: false,
                roles: [],
                permissions: [],
                branches: []
            }
        };
    },

    methods: {
        async fetchSelects() {
            await axios.get("/admin/roles/all").then(response => {
                this.selects.roles = response.data.data;
            });

            await axios.get("/admin/permissions/all").then(response => {
                this.selects.permissions = response.data.data;
            });

            await axios.get("/admin/branches/all").then(response => {
                this.selects.branches = response.data.data;
            });

            this.selects.ready = true;
        },

        onFetch() {
            this.entry.permissions = this.entry.permissions.map(permission => {
                return permission.id;
            });

            this.entry.role = this.entry.roles[0];
            this.entry.roles = this.entry.roles.map(role => {
                return role.id;
            });
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>
